<template>
  <div class="noteHolder">
    <div class="noteDisplay peopleSection" v-if="showMemberDetails && memberDisplay !== false">
      <div class="noteTop">
        <div class="noteContent">
          <h1>{{memberDisplay.firstName}} {{memberDisplay.lastName}}</h1>
          <p class="personEmail" v-if="memberDisplay.email">{{memberDisplay.email}}</p>
          <img
            v-if="memberDisplay.profilePicDetails.length > 0"
            class="personImage"
            :src="'https://fisher.communitybiblestudy.org/Images/PeoplePictures/' + memberDisplay.profilePicDetails[0].filePath"
          />
          <img v-else class="personImage" src="../../assets/profile-icon.png" />
        </div>
      </div>
      <div class="noteContent">
        <h2>User information</h2>
        <p class="noteInfo" v-if="memberDisplay.birthDate !== null">
          Birthday:
          <span>{{memberDisplay.birthMonth | monthOfYear}} {{memberDisplay.birthDate | dayOfMonth}}</span>
        </p>
        <p
          class="noteInfo"
          v-if="memberDisplay.address.address && memberDisplay.address.city && memberDisplay.address.state && memberDisplay.address.zipCode"
        >
          Address:
          <span>{{memberDisplay.address.address}}, {{memberDisplay.address.city}}, {{memberDisplay.address.state.name}}  {{memberDisplay.address.zipCode}}</span>
        </p>
        <p class="noteInfo" v-if="memberDisplay.email">
          E-Mail:
          <span>{{memberDisplay.email}}</span>
        </p>
        <p class="noteInfo">
          Gender:
          <span>{{memberDisplay.gender.genderName | capitalize}}</span>
        </p>
        <p class="noteInfo" v-if="!memberDisplay.isAdult">
          Child:
          <span>True</span>
        </p>
        <p class="noteInfo" v-if="memberDisplay.primaryContactNo">
          Contact Number:
          <span>{{memberDisplay.primaryContactNo | formatPhoneNumber}}</span>
        </p>
        <br />
        <div v-if="!memberDisplay.isAdult && memberDisplay.childGuardianInfo.length">
          <h2>Guardian</h2>
          <template v-for="guardian in memberDisplay.childGuardianInfo">
            <div v-if="guardian.isPrimaryGuardian === true" :key="guardian.email">
              <h4>{{guardian.firstName}} {{guardian.lastName}}</h4>
              <p class="noteInfo">
                Contact Number:
                <span>{{guardian.primaryContactNo | formatPhoneNumber}}</span>
              </p>
              <p class="noteInfo">
                E-Mail:
                <span>{{guardian.email}}</span>
              </p>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  components: {},
  name: "PeopleDisplay",
  methods: {
    ...mapMutations(["setMemberDisplay"]),
  },
  computed: mapGetters([
    "eventDisplay",
    "memberDisplay",
    "showMeetingDetails",
    "showEventDetails",
    "showMemberDetails",
  ]),
  filters: {
    capitalize: function (value) {
      if (value) {
        value = value.toString().toLowerCase();
        return value.charAt(0).toUpperCase() + value.slice(1);
      }
    },
    formatPhoneNumber: function (number) {
      if (number) {
        number = number.toString();
        number = number.replace("-", "");
        return (
          number.substring(0, 3) +
          " " +
          "-" +
          " " +
          number.substring(3, 6) +
          " " +
          "-" +
          " " +
          number.substring(6, 10)
        );
      }
    },
    monthOfYear: function (month) {
      if (month) {
        return [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ][month - 1];
      }
    },
    dayOfMonth: function (day) {
      if (day > 3 && day < 21) return day + "th";
      switch (day % 10) {
        case 1:
          return day + "st";
        case 2:
          return day + "nd";
        case 3:
          return day + "rd";
        default:
          return day + "th";
      }
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped src="@/styles/style-noteDisplay.scss">
</style>